import { useEffect, useState } from 'react'

import { ONE_SECOND_TIMER } from 'shared/constants'
import { getTimeDifference } from 'shared/lib/getTimeDifference'

const useCountdownTimer = (expiredDate: string) => {
  const [timeLeft, setTimeLeft] = useState(() => getTimeDifference(expiredDate))

  useEffect(() => {
    const update = () => {
      const diff = getTimeDifference(expiredDate)
      setTimeLeft(diff)
      if (diff.total <= 0) clearInterval(timer)
    }
    const timer = setInterval(update, ONE_SECOND_TIMER)
    update()
    document.addEventListener('visibilitychange', update)
    window.addEventListener('pageshow', update)

    return () => {
      clearInterval(timer)
      document.removeEventListener('visibilitychange', update)
      window.removeEventListener('pageshow', update)
    }
  }, [expiredDate])

  return timeLeft
}

export default useCountdownTimer
